import React, { useCallback, useState } from "react";
import ConfirmationLock from "../Milestone/confirmLock";
import toast from "react-hot-toast";

function ToggleInput({ name, setValue, defaultValue,epicData }) {
  const [confirmPopup, setConfirmPopup] = useState(false);

  const handleIslock = useCallback(() => {
    if (epicData?.start_date && epicData?.target_release_date) setConfirmPopup(true);
    else toast.error("Please set start and target date");
  }, []);

  const callback = useCallback(() => {
    setConfirmPopup(false);
  }, []);
  return (
    <>
      <label className="switch">
        <input
          type="checkbox"
          value={defaultValue}
          checked={defaultValue}
          // defaultValue={defaultValue}
          onChange={handleIslock}
        />
        <div className={`slider `}></div>
      </label>
      <ConfirmationLock
        open={confirmPopup}
        title={name}
        is_locked={defaultValue}
        message={
          defaultValue
            ? "Add a comment to Unlock Milestone"
            : "Add a comment to Lock Milestone"
        }
        btnTitle={"Confirm"}
        callback={callback}
        handleClose={() => setConfirmPopup(false)}
      />
    </>
  );
}

export default React.memo(ToggleInput);
